/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rhea Adhikari's Portfolio",
  description:
    "I'm a software engineer with a knack for solving problems and building products. Beyond tech, I'm fueled by a love to play sports and travel.",
  og: {
    title: "Rhea's Portfolio",
    type: "Website",
    url: "https://rheaadhikari.netlify.app/",
  },
};

//Home Page
const greeting = {
  title: "Rhea Adhikari",
  logo_name: "RheaAdhikari",
  subTitle:
    "I'm a software engineer with a knack for solving problems and building products. Beyond tech, I'm fueled by a love to play sports and travel.",
  resumeLink:
    "https://drive.google.com/file/d/1gDpj8yluGhBAWeJ-5BjT8OUbtHJ8abB2/view?usp=sharing",
  githubProfile: "https://github.com/RheaAdh",
  projectProfile: "https://github.com/RheaAdh",
};

const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rhea-adhikari/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Github",
    link: "https://github.com/RheaAdh",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Medium",
    link: "https://medium.com/@rheadhikari",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Gmail",
    link: "mailto:rheadhikari@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/rheadhikari",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/rheadhikari/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#FF0069", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "CricHeroes",
    link:
      "https://cricheroes.com/player-profile/27976257/rhea-adhikari/matches",
    fontAwesomeIcon: "fa-solid fa-baseball-bat-ball", // Trophy icon for sports achievements
    backgroundColor: "#FF6B35", // Orange color for cricket/sports
  },
  {
    name: "Hugging Face",
    link: "https://huggingface.co/rheadhikari",
    fontAwesomeIcon: "fa-robot", // AI/ML icon for Hugging Face
    backgroundColor: "#FF6B6B", // Pink color for AI/ML
  },
];

const skills = {
  data: [
    {
      title: "Product Management",
      fileName: "ProductManagementImg",
      imagePath: "devops.png",
      skills: [
        "⚡ Leading product strategy and vision, defining roadmaps aligned with business objectives and user needs.",
        "⚡ Conducting user research, analyzing data, and making data-driven decisions to improve product metrics.",
        "⚡ Collaborating with engineering, design, and cross-functional teams to deliver impactful products.",
        "⚡ Managing product lifecycles from ideation to launch, including feature prioritization and backlog management.",
        "⚡ Defining and tracking KPIs, running A/B tests, and measuring product success through analytics.",
      ],
      softwareSkills: [
        // Product Strategy & Vision
        {
          skillName: "Product Strategy",
          fontAwesomeClassname: "fa-solid:chart-line",
          style: {
            color: "#667eea",
          },
        },
        {
          skillName: "Roadmap Planning",
          fontAwesomeClassname: "fa-solid:route",
          style: {
            color: "#764ba2",
          },
        },
        {
          skillName: "Stakeholder Management",
          fontAwesomeClassname: "fa-solid:users",
          style: {
            color: "#f093fb",
          },
        },
        // User Research & Insights
        {
          skillName: "User Research",
          fontAwesomeClassname: "fa-solid:user-check",
          style: {
            color: "#4ecdc4",
          },
        },
        // Agile & Process
        {
          skillName: "Agile/Scrum",
          fontAwesomeClassname: "fa-solid:tasks",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "JIRA",
          fontAwesomeClassname: "logos:jira",
          style: {
            color: "#0052CC",
          },
        },
        {
          skillName: "Confluence",
          fontAwesomeClassname: "logos:confluence",
          style: {
            color: "#172B4D",
          },
        },
        // Product Tools
        {
          skillName: "Figma",
          fontAwesomeClassname: "logos:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Notion",
          fontAwesomeClassname: "logos:notion",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Technical Skills (Core Skills)
const techSkills = {
  data: [
    {
      title: "Fullstack Development & DevOps",
      fileName: "TechSkillsImg",
      imagePath: "devops.png",
      skills: [
        "⚡ Building and managing robust backend systems with Java/Spring Boot, Node.js, and databases for scalable applications.",
        "⚡ Containerizing and orchestrating services with Docker and Kubernetes for reliable deployments.",
        "⚡ AWS: EC2 for compute, S3 for storage, Lambda for serverless, DynamoDB for NoSQL, EventBridge for event-driven architectures.",
        "⚡ Implementing CI/CD and IaC with Terraform and Helm for reproducible infrastructure and fast releases.",
        "⚡ Designing and developing responsive UIs with React, HTML5, and CSS3.",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#ED8B00",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "logos:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "fa-brands:node",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "logos:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#DC382D",
          },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "logos:kafka",
          style: {
            color: "#231F20",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "logos:terraform",
          style: {
            color: "#7B42BC",
          },
        },
        {
          skillName: "Helm Chart",
          fontAwesomeClassname: "logos:helm",
          style: {
            color: "#0F1689",
          },
        },
        {
          skillName: "Spinnaker",
          fontAwesomeClassname: "logos:spinnaker",
          style: {
            color: "#139BB4",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "logos:c",
          style: {
            color: "#00599C",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F6BE00",
      },
      profileLink: "https://leetcode.com/rhea06/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/rheadhikari",
    },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "https://codeforces.com/profile/rhea_adhikari",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/rhea_adhikari",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@rhea39",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Manipal Institute Of Technology, Manipal",
      subtitle: "Bachelor of Technology in Computer Science and Engineering",
      logo_path: "mit_logo.png",
      alt_name: "MIT Manipal",
      duration: "2019 - 2023",
      descriptions: [
        "⚡ CGPA: 9.05/10.0",
        "⚡ Board Member at IECSE ( Computer Science Club @MIT ).",
        "⚡ Vice Captain Women's Football Team.",
        "⚡ Captain Women's Table Tennis (B) Team.",
        "⚡ System Admin Webdev Team ( Cultural Fest ).",
      ],
      website_link: "https://manipal.edu/mu.html",
    },
    {
      title: "Primus PU College, Bangalore",
      subtitle: "Core Subjects: Math, Computer Science, Physics, Chemistry",
      logo_path: "primus.png",
      alt_name: "Primus PU College",
      duration: "2017 - 2019",
      descriptions: ["⚡ Percentage: 96.75"],
      website_link: "https://primus.edu.in/",
    },
  ],
};

const awards = {
  awards: [
    {
      title: "Google Girl Hackathon: 1st Runners Up in India",
      subtitle: "Built a prototype to acclimatize senior citizens to apps",
      logo_path: "google_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1L6JGfb2EexycFVQp_Ao-kAfyLxrybtyE/view?usp=sharing",
      alt_name: "Google",
      color_code: "#D83B01",
    },
    {
      title: "Code Hack-a-Noodle Hackathon: Got an SDE offer from Zomato",
      subtitle: "Created a decentralized library",
      logo_path: "hackanoodle.png",
      certificate_link:
        "https://www.hackerearth.com/challenges/competitive/hackanoodle-code-to-inspire/",
      alt_name: "Zomato | Blinkit",
      color_code: "#4285F4",
    },
    {
      title: "General Electric Hack-e-Health: 2nd Runners Up in India",
      subtitle: "Created a Progressive Web Application",
      logo_path: "ge.png",
      certificate_link:
        "https://drive.google.com/file/d/1mevuDJWEDqiDNOLNwR4BXELZYnzp-YwF/view?usp=sharing",
      alt_name: "GE Healthcare",
      color_code: "#D83B01",
    },
    // {
    //   title: "Google Girl Hackathon - 2nd Position",
    //   subtitle: "MAHE Newsletter",
    //   logo_path: "google.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1OQ4GxA8H9wwsfAOYVtloaidzl8BrXwc-/view?usp=sharing",
    //   alt_name: "Google India",
    //   color_code: "#ffffff",
    // },
    {
      title: "Fitness Certification",
      subtitle: "Udemy",
      logo_path: "udem.png",
      certificate_link:
        "https://drive.google.com/file/d/1untNB5WcZQ3oRO34HLq6iOTV-B0JWoII/view",
      alt_name: "Udemy",
      color_code: "#ffffff",
    },
    {
      title: "AWS Technical Essentials",
      subtitle: "Amazon Web Services",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/file/d/1ysolDISQ6ZvlzB9Tuex2EmoyVspw6I61/view?usp=sharing",
      alt_name: "Amazon Web Services",
      color_code: "#ffffff",
    },
    {
      title: "Strategic AI",
      subtitle: "Artificial Intelligence",
      logo_path: "uccs.jpg",
      certificate_link:
        "https://drive.google.com/file/d/16JB7vAV6beLF0gWVgDZhsyxI_J_nnN4S/view?usp=drive_link",
      alt_name: "Universiity of Colorado Springs",
      color_code: "#ffffff",
    },
    {
      title: "Flying Start Program",
      subtitle: "Salesforce",
      logo_path: "dow.png",
      certificate_link:
        "https://drive.google.com/file/d/1Sbe39Axt-3oYwZOzi6AxuEb6uvn51LKr/view?usp=sharing",
      alt_name: "Salesforce",
      color_code: "#ffffff",
    },
    {
      title: "ICPC 2021",
      subtitle: "Gwalior-Pune",
      logo_path: "icpc.png",
      certificate_link:
        "https://drive.google.com/file/d/1Sb7OBRoNzpllkTu62zqTmxtsPWwRrIjy/view?usp=sharing",
      alt_name: "ICPC",
      color_code: "#ffffff",
    },
    {
      title: "MERN Stack Course",
      subtitle: "Full stack Development",
      logo_path: "udem.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-5e8fd074-31e9-43ba-a881-d64f5e26b4f4/",
      alt_name: "Udemy",
      color_code: "#ffffff",
    },
    {
      title: "Best Batter",
      subtitle: "County Yearly Award",
      logo_path: "best_batter_yearly.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1PoZP5_GbMVpoL5WYUJwUgRvy_8nb_M9O/view?usp=drive_link",
      alt_name: "County Cricket",
      color_code: "#ffffff",
    },
    {
      title: "Best Fielder",
      subtitle: "County Yearly Award",
      logo_path: "best_fielder_yearly.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1exXEOO1KuaIJmnzFhOCEIW7fEqTGoVss/view?usp=drive_link",
      alt_name: "County Cricket",
      color_code: "#ffffff",
    },

    // {
    //   title: "[Newsletter] General Electric Hackathon",
    //   subtitle: "MAHE Newsletter",
    //   logo_path: "ge_health.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1cjPnpVCblmiMogu9kEWnTUGMCobQr5Vz/view?usp=share_link",
    //   alt_name: "ge hack position",
    //   color_code: "#ffffff",
    // },
    {
      title: "Machine Learning with Big Data",
      subtitle: "Coursera",
      logo_path: "coursera.png",
      certificate_link:
        "https://coursera.org/share/3c209a6f5a5f55441c152a2f4416cb43",
      alt_name: "coursera",
      color_code: "#ffffff",
    },

    {
      title: "Graph Analytics for Big Data",
      subtitle: "Coursera",
      logo_path: "coursera.png",
      certificate_link:
        "https://coursera.org/share/dab9acd043ccda6a3a7d9df65308bba0",
      alt_name: "coursera",
      color_code: "#ffffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  // subtitle: "FTE, Internships ,Volunteership and Hackathons",
  description: "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "SDE | Rewards",
          company: "Dream11",
          company_url: "https://www.dream11.com/",
          logo_path: "dream11.jpg",
          duration: "January 2025 - Present",
          location: "Mumbai, Maharashtra",
          description:
            "• Re-architected Streaks feature for 256M users with real-time processing\n• Led POLAR migration for Spinwin and DreamBox services\n• Built dynamic auto-scaling system using EventBridge and Lambda\n• Authored 78 business acceptance tests for scalable backend",
          color: "#ee3c26",
        },
        {
          title: "SDE | Asset Inventory",
          company: "Salesforce",
          company_url: "https://www.salesforce.com/in/",
          logo_path: "dow.png",
          duration: "August 2023 - January 2025",
          location: "Bangalore, Karnataka",
          description:
            "• Built data ingestion pipeline for servers, network devices, and AWS resources\n• Streamlined CI/CD processes and resolved technical debt in deployment pipelines\n• Set up Docker containers and AWS infrastructure using Terraform\n• Orchestrated Kubernetes deployments with Helm charts and Spinnaker\n• Served on-call rotation ensuring high-quality data ingestion",
          color: "#ee3c26",
        },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "SDE Intern | Insurance Store",
          company: "Amazon",
          company_url: "https://www.amazon.in/",
          logo_path: "amazon.png",
          duration: "January 2023 - June 2023",
          location: "Bangalore, Karnataka",
          description:
            "• Built Data Exploration Debugging Tool (Java + JSP) reducing UAT time by 83%\n• Implemented secure authentication and authorization systems\n• Developed comprehensive test coverage with JUnit5, Mockito, and Lugia",
          color: "#ee3c26",
        },
        {
          title: "SDE Intern | Asset Inventory",
          company: "Salesforce",
          company_url: "https://www.salesforce.com/in/",
          logo_path: "dow.png",
          duration: "June 2022 - July 2022",
          location: "Bangalore",
          description:
            "• Built B2B asset relationship extraction system from inventory\n• Optimized API performance by migrating from REST to GraphQL\n• Developed efficient solution using Spring Boot, MySQL, and GraphQL",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Leadership",
      experiences: [
        {
          title: "Executive Board",
          company: "IECSE",
          company_url: "https://www.iecsemanipal.com/",
          logo_path: "iecse.png",
          duration: "Aug 2022 - May 2023",
          location: "Manipal, Karnataka",
          description:
            "• Led 120+ member team for tech fests and workshops\n• Organized events promoting technological knowledge\n• Enhanced technical culture across the institute",
          color: "#D83B01",
        },
        // {
        //   title: "MTTN",
        //   company: "Mozilla",
        //   company_url: "https://www.mozilla.org/",
        //   logo_path: "mozilla_logo.png",
        //   duration: "Oct 2019 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
        //   color: "#000000",
        // },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "Google Girl Hackathon: 1st Runners Up in India",
          company: "Google",
          company_url:
            "https://drive.google.com/file/d/1L6JGfb2EexycFVQp_Ao-kAfyLxrybtyE/view?usp=sharing",
          logo_path: "google_logo.png",
          duration: "April 2022",
          location: "Online",
          description:
            "• 1st Runners Up out of 3000 teams in India's first Google Girl Hack\n• Built prototype to help senior citizens adapt to mobile apps\n• Developed in-app tutorial with object detection and voice overlays",
          color: "#D83B01",
        },
        {
          title: "Code Hack-a-Noodle Hackathon: Got an SDE offer from Zomato",
          company: "Zomato | Blinkit",
          company_url:
            "https://www.hackerearth.com/challenges/competitive/hackanoodle-code-to-inspire/",
          logo_path: "hackanoodle.png",
          duration: "November 2022",
          location: "Bangalore, Karnataka",
          description:
            "• Top 100 out of 4000 participants in coding challenge\n• Created decentralized library solution\n• Developed unicorn idea in 24-hour onsite hackathon",
          color: "#4285F4",
        },
        {
          title: "General Electric Hack-e-Health: 2nd Runners Up in India",
          company: "GE Healthcare",
          duration: "December 2021",
          location: "Manipal, Karnataka",
          description:
            "• 2nd Runners Up representing Manipal Institute of Technology\n• Developed Progressive Web Application for healthcare\n• Built solution to keep users updated about vulnerabilities",
          logo_path: "ge.png",
          company_url:
            "https://drive.google.com/file/d/1mevuDJWEDqiDNOLNwR4BXELZYnzp-YwF/view?usp=sharing",
          color: "#D83B01",
        },
        // {
        //   title: "MTTN",
        //   company: "Mozilla",
        //   company_url: "https://www.mozilla.org/",
        //   logo_path: "mozilla_logo.png",
        //   duration: "Oct 2019 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
        //   color: "#000000",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Full stack projects .",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Projects Data
const projects = {
  projects: [
    {
      name: "Revels Website | Cultural Fest",
      description: "Head of System Admin and Web Development",
      github_link: "https://github.com/RheaAdh/revels-website",
      external_link: "https://github.com/RheaAdh/revels-website",
      image_path: "revels.png",
      languages: ["React", "Node.js", "MongoDB", "Express"],
      color: "#FF6B35",
    },
    {
      name: "Order Of Chaos | Tech Fest",
      description: "Organizing Committee - Backend Development",
      github_link: "https://github.com/RheaAdh/order-of-chaos",
      external_link: "https://github.com/RheaAdh/order-of-chaos",
      image_path: "ooc.png",
      languages: ["Java", "Spring Boot", "MySQL", "REST API"],
      color: "#61DAFB",
    },
  ],
};

// Testimonials Data
const testimonials = {
  testimonials: [
    {
      name: "Anurag Singh Bhadauria",
      position: "Rhea's Senior",
      company: "SALESFORCE",
      image: "testimonial1.jpg", // You can add actual photos
      testimonial:
        "Even though this was her first full time role, she was able to understand the system and deliver impactful work in minimal time. She created multiple asset ingestion jobs in our ETL framework expanding the inventory coverage which in turn improved security scanning and coverage. She was able to understand and onboard our service to latest internal tools, consolidating and optimizing deployment workflows resulting in improved developer productivity.",
      rating: 5,
    },
    {
      name: "Saurav Uppoor",
      position: "Rhea's Senior",
      company: "AMAZON",
      image: "testimonial2.jpg",
      testimonial:
        "Worked alongside Rhea during her internship at Amazon. As part of the internship, Rhea worked on different areas of software development such as Integration tests, Infrastructure, Security practices, Low level design, Operational excellence etc. She was able to ramp up quickly with minimal help and also completed all her key deliverables. Her remarkable work ethic and skills makes her a valuable asset to any organisation.",
      rating: 5,
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "📩 Let's Connect! 📩",
    profile_image_path: "rhea.png",
    description:
      "I'm always excited to connect with fellow professionals, industry experts, and anyone passionate about technology and innovation. Feel free to reach out if you'd like to discuss new opportunities, share insights, or just chat about our shared interests.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://ashutoshhathidara.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8320758513",
  },
};

// Product Portfolio Section - Optimized for Product Manager Roles
const productPortfolio = {
  products: [
    {
      title: "Design-to-Code Specialist",
      description:
        "Agentic solution that detects Figma changes, alerts teams with fixes, validates PRs for pixel accuracy, and improves using Jira and GitHub feedback.",
      image: "ema.png",
      link:
        "https://drive.google.com/file/d/1UBZa1RwH6W5SxBMo2wxCcf1KjVxOd1mm/view?usp=sharing",
      userSegments: ["UI/UX Designers", "Frontend Engineers"],
    },
    {
      title: "Zoho Mail for Enterprises",
      description:
        "Zoho Mail – Building a Competitive Advantage in Enterprise SaaS and compete against legacy players.",
      image: "zoho.png",
      link:
        "https://www.canva.com/design/DAG4KCbevBo/xB5_Fva4UWz9G3OgyJVi7g/edit?utm_content=DAG4KCbevBo&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton",
      userSegments: [
        "Enterprise Customers",
        "Small Businesses",
        "Medium-sized Enterprises",
      ],
    },
    {
      title: "Enhanced GMAIL UX",
      description:
        "Solved for GMAIL pain points to enhance user experience and engagement.",
      image: "gmail.png",
      link:
        "https://docs.google.com/document/d/1tFjr7kepDVHkbJdckY_v3SHY1-tb7JleU_hX2zHorn0/edit?usp=sharing",
      userSegments: ["Individual Gmail Users", "Team and Business Personas"],
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  techSkills,
  competitiveSites,
  degrees,
  awards,
  experience,
  projects,
  projectsHeader,
  publicationsHeader,
  testimonials,
  contactPageData,
  productPortfolio,
};
